module.exports = "<svg style=\"width: 16px; height: 16px\" viewBox=\"0 0 16 16\"><polygon id=\"path-1\" points=\"8 6.58578644 2.34314575 0.928932188 0.928932188 2.34314575 6.58578644 8 0.928932188 13.6568542 2.34314575 15.0710678 8 9.41421356 13.6568542 15.0710678 15.0710678 13.6568542 9.41421356 8 15.0710678 2.34314575 13.6568542 0.928932188\"></polygon></svg>"


//////////////////
// WEBPACK FOOTER
// ./assets/icons/x.svg
// module id = 265
// module chunks = 0